import { Voni } from '../client';

export interface CaptchaResponse {
  token: string;
  question: string;
}

export interface VerifyCaptchaResponse {
  success: boolean;
  message?: string;
}

export class CaptchaResource {
  constructor(private client: Voni) {}

  /**
   * Get a new CAPTCHA challenge for the project.
   */
  async getChallenge(projectId: string): Promise<CaptchaResponse> {
    return this.client.request<CaptchaResponse>('GET', `/widget/${projectId}/captcha`);
  }

  /**
   * Verify a CAPTCHA answer.
   */
  async verifyChallenge(projectId: string, token: string, answer: string): Promise<VerifyCaptchaResponse> {
    const data = {
      token,
      answer,
    };
    return this.client.request<VerifyCaptchaResponse>('POST', `/widget/${projectId}/captcha/verify`, undefined, data);
  }
}
